import {
  getPageExcludeSelector,
  getWidgetShadowRoot,
  removeScopedStyleTag,
  upsertScopedStyleTag,
} from "../../domStyles";
import { getFeatureTarget } from "../../featureTargets";

const FEATURE_ID = "highlight-links";
const STYLE_ID = "incluway-highlight-links-style";
const PARENT_ATTR = "data-incluway-highlight-link-parent";

function markLinkParents(root: ParentNode) {
  root.querySelectorAll<HTMLAnchorElement>("a[href]").forEach((link) => {
    const parentButton = link.closest<HTMLElement>('button, [role="button"]');
    if (!parentButton) return;

    parentButton.setAttribute(PARENT_ATTR, "true");
  });
}

function clearLinkParents(root: ParentNode) {
  root.querySelectorAll<HTMLElement>(`[${PARENT_ATTR}]`).forEach((el) => {
    el.removeAttribute(PARENT_ATTR);
  });
}

export function enableHighlightLinks() {
  markLinkParents(document);

  const shadowRoot = getWidgetShadowRoot();
  if (shadowRoot) {
    markLinkParents(shadowRoot);
  }

  const pageExclude = getPageExcludeSelector();

  upsertScopedStyleTag({
    id: STYLE_ID,
    target: getFeatureTarget(FEATURE_ID, "both"),
    pageCss: `
a[href]${pageExclude} {
  text-decoration: underline !important;
  text-underline-offset: 4px !important;
  text-decoration-color: #0048ff !important;
  outline: 2px solid #0048ff !important;
  outline-offset: 1px !important;
  border-radius: 4px !important;
}

[${PARENT_ATTR}="true"]${pageExclude} {
  outline: 2px dashed #0048ff !important;
  outline-offset: 4px !important;
  border-radius: 6px !important;
}

button[disabled][${PARENT_ATTR}="true"]${pageExclude},
button[aria-disabled="true"][${PARENT_ATTR}="true"]${pageExclude},
[role="button"][aria-disabled="true"][${PARENT_ATTR}="true"]${pageExclude} {
  outline: none !important;
}
`.trim(),
    widgetCss: `
a[href] {
  text-decoration: underline !important;
  text-underline-offset: 4px !important;
  text-decoration-color: #0048ff !important;
  outline: 2px solid #0048ff !important;
  outline-offset: 1px !important;
  border-radius: 4px !important;
}

[${PARENT_ATTR}="true"] {
  outline: 2px dashed #0048ff !important;
  outline-offset: 4px !important;
  border-radius: 6px !important;
}

button[disabled][${PARENT_ATTR}="true"],
button[aria-disabled="true"][${PARENT_ATTR}="true"],
[role="button"][aria-disabled="true"][${PARENT_ATTR}="true"] {
  outline: none !important;
}
`.trim(),
  });
}

export function disableHighlightLinks() {
  clearLinkParents(document);

  const shadowRoot = getWidgetShadowRoot();
  if (shadowRoot) {
    clearLinkParents(shadowRoot);
  }

  removeScopedStyleTag(STYLE_ID);
}
